import { isValidEmail } from '@domain-group/javascript-utils'

export type AgentModel = {
  agency_id: number,
  agent_title?: string,
  business_name?: string,
  business_number?: string,
  cache_key: number,
  commission_fee?: number,
  commission_structure?: string,
  cover_letter?: string,
  email_notifications?: boolean,
  email?: string,
  first_name?: string,
  full_name: string,
  id: number,
  last_name?:string,
  license_number?: string,
  mobile?: string,
  other_enquiry_email?: string,
  profile_video_id?: string,
  profile_video_provider?: string,
  type?: string,
  user_id?: number,
}

export type AgentRequestOptions = {
  include_agent_user?: boolean,
  include_image_sizes?: boolean,
  include_user_image?: boolean,
}

const state = {
  agent_title: '',
  business_name: '',
  business_number: '',
  license_number: '',
  other_enquiry_email: '',
  profile: '',
}

// other_enquiry_email is not a required field but if present needs to be a valid email
export const requiredFields = [
  {
    invalidMessage: 'Invalid Email format',
    key: 'other_enquiry_email',
    validation: (email: string) => !email || isValidEmail(email),
  },
]

export default state
